/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Community_Vote_LabelInputs */

const en_us2_community_vote_label = /** @type {(inputs: Community_Vote_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vote for ${i?.title}`)
};

const pt_br2_community_vote_label = /** @type {(inputs: Community_Vote_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votar em ${i?.title}`)
};

const es_419_community_vote_label = /** @type {(inputs: Community_Vote_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votar por ${i?.title}`)
};

const pt_pt2_community_vote_label = /** @type {(inputs: Community_Vote_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Votar em ${i?.title}`)
};

const fr_fr2_community_vote_label = /** @type {(inputs: Community_Vote_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Voter pour ${i?.title}`)
};

const de_de2_community_vote_label = /** @type {(inputs: Community_Vote_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Für ${i?.title} stimmen`)
};

const it_it2_community_vote_label = /** @type {(inputs: Community_Vote_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Vota ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Vote for {title}" |
*
* @param {Community_Vote_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_vote_label = /** @type {((inputs: Community_Vote_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Vote_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_vote_label(inputs)
	if (locale === "es-419") return es_419_community_vote_label(inputs)
	if (locale === "pt-PT") return pt_pt2_community_vote_label(inputs)
	if (locale === "fr-FR") return fr_fr2_community_vote_label(inputs)
	if (locale === "de-DE") return de_de2_community_vote_label(inputs)
	if (locale === "it-IT") return it_it2_community_vote_label(inputs)
	return en_us2_community_vote_label(inputs)
});
export { community_vote_label as "community.vote_label" }